import { Page, PageTitle } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { CRUDToolbar } from "@/components/page/crudtoolbar"
import { useDatabaseItem, usePage } from "@/components/page/hooks"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Textarea } from "@/components/ui/textarea"
import { zodResolver } from "@hookform/resolvers/zod"
import { LayoutList } from "lucide-react"
import { useForm } from "react-hook-form"
import { z } from "zod"


const FormSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
})

type FormData = z.infer<typeof FormSchema>

type EvalCat = Table<"eval_categories">

export function Evalcats_CRUD() {

  const { team } = usePage()
  const { data, loading, submit, toastSuccess, navigate } = useDatabaseItem("eval_categories")

  const form = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: data as FormData,
    values: data as FormData,
  })

  async function onSubmit(data: EvalCat) {
    data.team = team?.id
    await submit(data)
    toastSuccess()
    navigate("/evaluations/evalcats")
  }

  if (loading) return <CRUDLoader />

  return <Page>
    <div className="pb-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <PageTitle>
            <CRUDToolbar table="eval_categories" onSuccess="/evaluations/evalcats" />
          </PageTitle>
          <div className="rgrid">
            <div className="row">
              <div className="rc-12">
                <FormField control={form.control} name="name" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Name</FormLabel>
                    <FormControl><Input {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
              <div className="rc-12">
                <FormField control={form.control} name="description" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Description</FormLabel>
                    <FormControl><Textarea {...field} /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
          </div>
        </form>
      </Form>
    </div>
  </Page>

}
